<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<div class="overlay-content" *ngIf="isVisible">
  <div class="panel">
    <div class="panel-header">
      <img class="close-button ml-2" (click)="cancelEdit(); togglePanel('')" src="/assets/images/close.png" alt="">
      <!-- <button class="btn btn-blue ml-3" (click)="editDetails()">Edit</button> -->
      <!-- <img class="editImg" (click)="editDetails()" [src]="bucketurl + '/icons/edit-1.png'" alt="" title="Edit"> -->

      <span *ngIf="leadDetails?.current_stage?.stage_id !== 5 && leadDetails?.current_stage?.stage_id !== 6"
        class="move">Move To <i class="fa fa-angle-double-right" aria-hidden="true"></i>
      </span>
      <div class="action-buttons ml-3">
        <button *ngIf="leadDetails?.current_stage?.stage_id !== 5 && leadDetails?.current_stage?.stage_id !== 6"
          class="btn btn-blue" (click)="openDialog()">
          <img src="/assets/images/sales-manager.png" alt="">
          DSE
        </button>
        <button
          *ngIf="leadDetails?.current_stage?.stage_id !== 7 && leadDetails?.current_stage?.stage_id !== 5 && leadDetails?.current_stage?.stage_id !== 6"
          class="btn btn-orange" (click)="followupDialog()">
          <img class="btn-img" src="/assets/images/followup.png" alt=""> Follow up
        </button>
        <button
          *ngIf="leadDetails?.current_stage?.stage_id !== 7 && leadDetails?.current_stage?.stage_id !== 5 && leadDetails?.current_stage?.stage_id !== 6"
          class="btn btn-grey" (click)="noresponseDialog()"> <img class="btn-img" src="/assets/images/no-response.png"
            alt=""> No
          Response</button>
        <button
          *ngIf="leadDetails?.current_stage?.stage_id !== 7 && leadDetails?.current_stage?.stage_id !== 5 && leadDetails?.current_stage?.stage_id !== 6"
          class="btn btn-voilet" (click)="nonsalesDialog(false)"><img class="btn-img" src="/assets/images/non-sales.png"
            alt=""> Non-Sales</button>
        <button
          *ngIf="leadDetails?.current_stage?.stage_id !== 7 && leadDetails?.current_stage?.stage_id !== 5 && leadDetails?.current_stage?.stage_id !== 6"
          class="btn btn-red" (click)="lostjunkDialog()"><img class="btn-img" src="/assets/images/junk.png" alt="">
          Drop/Junk</button>
        <button class="btn btn-blue" (click)="openHistory()"><img class="btn-img" src="/assets/images/clock.png" alt="">
          Lead History</button>
      </div>

    </div>
    <div class="panel-content">
      <div class="table-container">
        <div class="row">
          <div class="col-md-6 mt-3">
            <table class="table table-bordered">
              <tbody>
                <ng-container [formGroup]="productForm">

                  <tr>
                    <td class="sub-head">First Name <span class="alert-small">*</span></td>
                    <td style="word-break: break-word;" *ngIf="!isEditMode">{{ leadDetails.first_name || '-' }}</td>
                    <td *ngIf="isEditMode"><input (keyup)="onFieldEdit()" type="text" class="form-control"
                        formControlName="first_name" onkeydown="return /^[a-zA-Z]*$/i.test(event.key)" [ngClass]="{ 'is-invalid': submitted && f['first_name'].errors }">
                      <div *ngIf="submitted && f['first_name'].errors" class="invalid-feedback">
                        <div *ngIf="productForm.get('first_name')?.errors?.['required']" class="error-msg">
                          First Name is required.
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                 <tr>
                  <td class="sub-head">Middle Name</td>
                  <td style="word-break: break-word;" *ngIf="!isEditMode">{{ leadDetails.middle_name || '-' }}</td>
                  <td *ngIf="isEditMode"><input (keyup)="onFieldEdit()" onkeydown="return /^[a-zA-Z]*$/i.test(event.key)" type="text" class="form-control"
                      [(ngModel)]="leadDetails.middle_name"></td>
                </tr>
                <tr>
                  <td class="sub-head">Last Name</td>
                  <td style="word-break: break-word;" *ngIf="!isEditMode">{{ leadDetails.last_name || '-' }}</td>
                  <td *ngIf="isEditMode"><input (keyup)="onFieldEdit()" onkeydown="return /^[a-zA-Z]*$/i.test(event.key)" type="text" class="form-control"
                      [(ngModel)]="leadDetails.last_name"></td>
                </tr>
                <tr>
                  <td class="sub-head">Email ID</td>
                  <td *ngIf="emailID != '' && emailID != null || !isEditMode"
                    style="text-transform: lowercase;word-break: break-word;"> {{ leadDetails.email || '-' }}</td>
                  <td *ngIf="isEditMode && emailID == '' || isEditMode && emailID == null">
                    <input (keyup)="onFieldEdit();validateEmail()" type="text" class="form-control"
                      [(ngModel)]="leadDetails.email" #email="ngModel" email>
                    <!-- <div *ngIf="email.invalid && (email.dirty || email.touched)" class="text-danger"
                      style="font-size: 11px;"> 
                      Enter valid email ID.
                    </div> -->
                    <div *ngIf="emailError" class="text-danger" style="font-size: 11px;text-transform:none">
                      Enter a valid email ID.
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">Alternate Email ID</td>
                  <td *ngIf="!isEditMode" style="text-transform: lowercase;word-break: break-word;">{{
                    leadDetails.alternate_email || '-' }}
                  </td>
                  <td *ngIf="isEditMode">
                    <input (keyup)="onFieldEdit()" (keyup)="validateAlternateEmail()" type="text" class="form-control"
                      [(ngModel)]="leadDetails.alternate_email" #alternateEmail="ngModel" email>
                    <!-- <div *ngIf="alternateEmail.invalid && (alternateEmail.dirty || alternateEmail.touched)"
                      class="text-danger" style="font-size: 11px;">
                      Enter valid alternate email.
                    </div> -->
                    <div *ngIf="alternateEmailError" class="text-danger" style="font-size: 11px;text-transform:none">
                      Enter a valid alternate email ID.
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">Phone Number</td>
                  <td>{{leadDetails?.mobile || '-'}}</td>
                </tr>
                <!-- <tr>
                  <td class="sub-head">Alternate Number</td>
                  <td>{{leadDetails.alternate_mobile || '-'}}</td>
                </tr> -->

                <tr>
                  <td class="sub-head">Alternate Number</td>
                  <td *ngIf="!isEditMode">{{ leadDetails.alternate_mobile || '-' }}</td>
                  <td *ngIf="isEditMode">
                    <input (keyup)="onFieldEdit()" type="text" class="form-control" onpaste="return false;"
                      [(ngModel)]="leadDetails.alternate_mobile" maxlength="10" (keyup)="validateMobileNumber()"
                      (keypress)="allowNumbersOnly($event)">
                    <div *ngIf="mobileNumberError" class="text-danger" style="font-size: 11px;text-transform:none">
                      Enter a valid 10-digit alternate number
                    </div>
                  </td>
                </tr>
                <ng-container [formGroup]="productForm">
                  <tr>
                    <td class="sub-head">Age Group <span class="alert-small">*</span></td>
                    <td *ngIf="!isEditMode">{{leadDetails?.age_group ? leadDetails?.age_group : '-'}}</td>
                    <td *ngIf="isEditMode">
                      <select style="font-size: 13px !important;" formControlName="age_group" class="form-select"
                        (change)="onFieldEdit()" [ngClass]="{ 'is-invalid': submitted && f['age_group'].errors }">
                        <option disabled selected value="">Select Age Group</option>
                        <ng-container *ngFor="let data of ageGroupList">
                          <option [value]="data.id + ':' + data.age_group"
                            [selected]="data.id + ':' + data.age_group == originalLeadDetails.ageGroupId">
                            {{ data.age_group }}
                          </option>
                        </ng-container>
                      </select>
                      <div *ngIf="submitted && f['age_group'].errors" class="invalid-feedback">
                        <div *ngIf="productForm.get('age_group')?.errors?.['required']" class="error-msg">
                          Please Select Age Group.
                        </div>
                      </div>
                    </td>
                  </tr>
                  <!-- <tr>
                  <td class="sub-head">Product Category</td>
                  <td>{{ leadDetails?.product_details?.product_category || '-' }}</td>
                </tr> -->
                  <tr>
                    <td class="sub-head">Product Category <span class="alert-small">*</span></td>
                    <td *ngIf="!isEditMode">{{ leadDetails?.product_details?.product_category || '-' }}</td>
                    <td *ngIf="isEditMode">
                      <select style="font-size: 13px !important;" formControlName="category" class="form-select"
                        (change)="onCategoryChange($event);onFieldEdit()"
                        [ngClass]="{ 'is-invalid': submitted && f['category'].errors }">
                        <option disabled selected value="">Select a Category</option>
                        <ng-container *ngFor="let category of categories">
                          <option [value]="category.id + ':' + category.product_categories">
                            {{ category.product_categories }}
                          </option>
                        </ng-container>
                      </select>
                      <div *ngIf="submitted && f['category'].errors" class="invalid-feedback">
                        <div *ngIf="productForm.get('category')?.errors?.['required']" class="error-msg">
                          Please Select Category.
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="sub-head">Product Model <span class="alert-small">*</span></td>
                    <td *ngIf="!isEditMode">{{ leadDetails?.product_details?.product_model || '-' }}</td>
                    <td *ngIf="isEditMode">
                      <select style="font-size: 13px !important;" formControlName="model" class="form-select"
                        (change)="onModelChange($event); onFieldEdit()"
                        [ngClass]="{ 'is-invalid': submitted && f['model'].errors }">
                        <option disabled selected value="">Select a Model</option>
                        <option *ngFor="let product of filteredProducts" [value]="product.id + ':' + product.model">
                          {{ product.model }}
                        </option>
                      </select>
                      <div *ngIf="submitted && f['model'].errors" class="invalid-feedback">
                        <div *ngIf="productForm.get('model')?.errors?.['required']" class="error-msg">
                          Please Select Product Model.
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="sub-head">Product Variant <span class="alert-small">*</span></td>
                    <td *ngIf="!isEditMode">{{ leadDetails?.product_details?.product_variant || '-' }}</td>
                    <td *ngIf="isEditMode">
                      <select style="font-size: 13px !important;" formControlName="variant" class="form-select"
                        (change)="onVariantChange($event); onFieldEdit()"
                        [ngClass]="{ 'is-invalid': submitted && f['variant'].errors }">
                        <option disabled selected value="">Select a Variant</option>
                        <option *ngFor="let product of filteredProductsVar"
                          [value]="product.id + ':' + product.variant">
                          {{ product.variant }}
                        </option>
                      </select>
                      <div *ngIf="submitted && f['variant'].errors" class="invalid-feedback">
                        <div *ngIf="productForm.get('variant')?.errors?.['required']" class="error-msg">
                          Please Select Product Variant.
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="sub-head">Product Color <span class="alert-small">*</span></td>
                    <td *ngIf="!isEditMode">{{ leadDetails?.product_details?.product_color || '-' }}</td>
                    <td *ngIf="isEditMode">
                      <select style="font-size: 13px !important;" formControlName="color" class="form-select"
                        (change)="onFieldEdit()" [ngClass]="{ 'is-invalid': submitted && f['color'].errors }">
                        <option disabled selected value="">Select a Color</option>
                        <option *ngFor="let color of filteredProductsColor" [value]="color.id + ':' + color.color">
                          {{ color.color }}
                        </option>
                      </select>
                      <div *ngIf="submitted && f['color'].errors" class="invalid-feedback">
                        <div *ngIf="productForm.get('color')?.errors?.['required']" class="error-msg">
                          Please Select Product Color.
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <tr>
                  <td class="sub-head">Lead Type</td>
                  <td>{{leadDetails.lead_type || '-'}}</td>
                </tr>
                <tr *ngIf="leadDetails.lead_type == 'Call'">
                  <td class="sub-head">Call Status</td>
                  <td>{{(leadDetails.call_status == 'Answered' || leadDetails.call_status == 'ANSWER') ? leadDetails.call_status : 'Missed Call' }}</td>
                </tr>
                <tr *ngIf="leadDetails?.current_stage?.stage_id == 7">
                  <td class="sub-head">Drop Reason</td>
                  <td *ngIf="!isEditMode">{{ leadDetails?.current_stage?.lost_reason || '-' }}</td>
                  <td *ngIf="isEditMode">
                    <select class="form-select" [(ngModel)]="originalLeadDetails.lost_reason" (change)="onFieldEdit()">
                      <option disabled selected value="">Select</option>
                      <option *ngFor="let lost_reason of preSalesLostReason"
                        [value]="lost_reason.id + ':' + lost_reason.reason">
                        {{ lost_reason.reason }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr *ngIf="leadDetails?.current_stage?.stage_id == 7 && leadDetails?.current_stage?.brand">
                  <td class="sub-head">Competitor's Brand</td>
                  <td>{{ leadDetails?.current_stage?.brand || '-' }}</td>
                </tr>
                <tr *ngIf="leadDetails?.current_stage?.stage_id == 7 && leadDetails?.current_stage?.compare_model">
                  <td class="sub-head">Competitor's Model</td>
                  <td>{{ leadDetails?.current_stage?.compare_model || '-' }}</td>
                </tr>
                <tr *ngIf="leadDetails?.current_stage?.stage_id == 5">
                  <td class="sub-head">Junk Reason</td>
                  <td *ngIf="!isEditMode">{{ leadDetails?.current_stage?.junk_reason || '-' }}</td>
                  <td *ngIf="isEditMode">
                    <select class="form-select" [(ngModel)]="originalLeadDetails.junk_reason" (change)="onFieldEdit()">
                      <option disabled selected value="">Select</option>
                      <option *ngFor="let junk_reason of junkReason"
                        [value]="junk_reason.id + ':' + junk_reason.reason">
                        {{ junk_reason.reason }}
                      </option>
                    </select>
                  </td>
                </tr>

                <tr *ngIf="leadDetails?.current_stage?.stage_id == 2">
                  <td class="sub-head">Follow Up Reason <span *ngIf="isEditMode" class="alert-small">*</span></td>
                  <td *ngIf="!isEditMode">{{ leadDetails?.current_stage?.followup_reason || '-' }}</td>
                  <td *ngIf="isEditMode">
                    <select class="form-select" [(ngModel)]="originalLeadDetails.followup_reason"
                      (change)="onFieldEdit()">
                      <option disabled selected value="">Select</option>
                      <option *ngFor="let followup_reason of followUpReason"
                        [value]="followup_reason.id + ':' + followup_reason.reason">
                        {{ followup_reason.reason }}
                      </option>
                    </select>
                  </td>
                </tr>

                <tr *ngIf="leadDetails?.current_stage?.stage_id == 2">
                  <td class="sub-head">Follow Up Date & Time <span *ngIf="isEditMode" class="alert-small">*</span></td>
                  <td *ngIf="!isEditMode">
                    <span class="date">{{ leadDetails.current_stage.next_followup_date | date: 'dd-MM-yyyy' }} </span>,
                    <span class="time">{{ leadDetails.current_stage.next_followup_date | date: 'shortTime' }}</span>
                  </td>
                  <td *ngIf="isEditMode">
                    <!-- <mat-form-field appearance="fill"> -->
                    <input class="datepick" matInput readonly [matDatepicker]="picker" (click)="picker.open()"
                      [ngModel]="originalLeadDetails.next_followup_date"
                      (ngModelChange)="onFieldEdit();originalLeadDetails.next_followup_date = formatDateForInput($event, 'YYYY-MM-DD')"
                      placeholder="Select Date">
                    <!-- <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle> -->
                    <mat-datepicker #picker></mat-datepicker>
                    <!-- </mat-form-field> -->
                    <!-- <input type="date" class="form-control" [(ngModel)]="originalLeadDetails.next_followup_date"> -->
                    <!-- <input type="time" class="form-control" [(ngModel)]="originalLeadDetails.next_followup_time"> -->
                    <mat-form-field appearance="outline">
                      <input (ngModelChange)="onFieldEdit();" type="text" readonly
                        [(ngModel)]="originalLeadDetails.next_followup_time" matInput [matTimepicker]="timepicker"
                        (click)="timepicker.open()" />
                      <mat-timepicker-toggle matSuffix [for]="timepicker"></mat-timepicker-toggle>
                      <mat-timepicker #timepicker touchUi mode="input" orientation="horizontal"></mat-timepicker>
                      <mat-hint>hh:mm</mat-hint>
                    </mat-form-field>
                  </td>
                </tr>

                <tr *ngIf="leadDetails.utm">
                  <td class="sub-head">UTM</td>
                  <td class="url-link">
                    <a href="{{leadDetails.utm}}" target="_blank">
                      {{leadDetails.utm}}
                    </a>
                  </td>
                </tr>
                <tr *ngIf="leadDetails?.utm_details?.utm_source">
                  <td class="sub-head">UTM Source</td>
                  <td class="url-link">
                    {{leadDetails?.utm_details?.utm_source || ''}}
                  </td>
                </tr>
                <tr *ngIf="leadDetails?.utm_details?.utm_medium">
                  <td class="sub-head">UTM Medium</td>
                  <td class="url-link">
                    {{leadDetails?.utm_details?.utm_medium || ''}}
                  </td>
                </tr>
                <tr *ngIf="leadDetails?.utm_details?.utm_campaign">
                  <td class="sub-head">UTM Campaign</td>
                  <td class="url-link">
                    {{leadDetails?.utm_details?.utm_campaign || ''}}
                  </td>
                </tr>
                <!-- <tr>
                  <td class="sub-head">Base Lead Source</td>
                  <td>{{leadDetails.base_lead_source || '-'}}</td>
                </tr> -->
                <tr>
                  <td class="sub-head">Lead Source</td>
                  <td>{{leadDetails.lead_source || '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Sub Source</td>
                  <td>{{leadDetails.lead_sub_source || '-'}}</td>
                </tr>
                <tr *ngIf="leadDetails?.reference_type_id  == 17">
                  <td class="sub-head">Reference Type</td>
                  <td>{{leadDetails?.reference_type || '-'}}</td>
                </tr>
                <tr *ngIf="leadDetails?.reference_type_id  == 17">
                  <td class="sub-head">Reference By</td>
                  <td>{{leadDetails?.reference_by || '-'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-6 mt-3">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <td class="sub-head">Lead Captured Date/Time</td>
                  <td>
                    <span class="date">{{ leadDetails.createdAt | date: 'dd-MM-yyyy' }}</span>,
                    <span class="time">{{ leadDetails.createdAt | date: 'hh:mm a' }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">Lead ID</td>
                  <td>{{leadDetails.lead_id || '-'}}</td>
                </tr>

                <tr>
                  <td class="sub-head">Reference Lead ID</td>
                  <td>{{leadDetails.unique_reference_number || '-'}}</td>
                </tr>

                <!-- <tr>
                  <td class="sub-head">Status</td>
                  <td [ngClass]="{'re-engaged' : leadDetails?.lead_status?.toLowerCase()== 're-engaged'}">
                    {{leadDetails.lead_status ||
                    '-'}}</td>
                </tr> -->
                <tr>
                  <td class="sub-head">Lead Stage</td>
                  <td style="padding:5px;"> <button class="btn btn-higlight" *ngIf="leadDetails?.current_stage?.stage">
                      {{leadDetails?.current_stage?.stage ? leadDetails?.current_stage?.stage : '-'}}
                    </button>
                  </td>
                </tr>
                <tr *ngIf="leadDetails?.current_stage?.stage_id == 6">
                  <td class="sub-head">Non-Sales Category</td>
                  <td> {{leadDetails?.current_stage?.non_sales_category || ''}} <button
                      *ngIf="!leadDetails?.current_stage?.non_sales_category" class="btn btn-voilet"
                      (click)="nonsalesDialog(true)"><img class="btn-img" src="/assets/images/non-sales.png" alt="">
                      Update
                    </button> <span *ngIf="leadDetails?.current_stage?.non_sales_category"><img
                        [src]="bucketurl + '/images/pen.png'" class="edit-pen" title="Edit"
                        (click)="nonsalesDialog(true)" /></span>
                  </td>
                </tr>
                <tr
                  *ngIf="leadDetails?.form_type == 'Service form' || (leadDetails?.current_stage?.stage_id == 6 && leadDetails?.current_stage?.non_sales_category_id==1) ">
                  <td class="sub-head">Service Booking Number</td>
                  <td> {{leadDetails?.po_appnt_no || ''}}
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">Lead Qualification</td>
                  <td [ngClass]="{
                    'priority-td': leadDetails?.current_stage?.lead_priority
                }">
                    <ng-container *ngIf="leadDetails.form_type != 'Test Drive form'">
                      <button class="btn" [ngClass]="{
                    'hot-class': leadDetails?.current_stage?.lead_priority?.toLowerCase() == 'hot',
                    'warm-class': leadDetails?.current_stage?.lead_priority?.toLowerCase() == 'warm',
                    'cold-class': leadDetails?.current_stage?.lead_priority?.toLowerCase() == 'cold'
                  }" *ngIf="leadDetails?.current_stage?.lead_priority">
                        {{leadDetails?.current_stage?.lead_priority ? leadDetails?.current_stage?.lead_priority : '-'}}
                      </button>
                    </ng-container>
                    <ng-container *ngIf="leadDetails.form_type == 'Test Drive form'">
                      <button class="btn" [ngClass]="{
                      'hot-class': leadDetails?.lead_qualification?.toLowerCase() == 'hot',
                      'warm-class': leadDetails?.lead_qualification?.toLowerCase() == 'warm',
                      'cold-class': leadDetails?.lead_qualification?.toLowerCase() == 'cold'
                    }" *ngIf="leadDetails?.lead_qualification">
                        {{leadDetails?.lead_qualification ? leadDetails?.lead_qualification : '-'}}
                      </button>
                    </ng-container>
                    <ng-container
                      *ngIf="!leadDetails?.lead_qualification && !leadDetails?.current_stage?.lead_priority">
                      -
                    </ng-container>
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">Customer Type</td>
                  <td>{{leadDetails?.customer_type || '-'}}</td>
                </tr>
                <tr *ngIf="leadDetails?.customer_type_id  == 1">
                  <td class="sub-head">Company Name</td>
                  <td>{{leadDetails?.company_name || '-'}}</td>
                </tr>
                <ng-container [formGroup]="productForm">

                  <tr>
                    <td class="sub-head">Buyer Type <span class="alert-small">*</span></td>
                    <td style="word-break: break-word;" *ngIf="!isEditMode">
                      {{leadDetails?.current_stage?.customer_interest || '-'}}</td>
                    <td *ngIf="isEditMode">
                      <select style="font-size: 12px !important;" formControlName="customer_interest"
                        class="form-select" (change)="onFieldEdit()"
                        [ngClass]="{ 'is-invalid': submitted && f['customer_interest'].errors }">
                        <option disabled selected value="">Select Buyer Type</option>
                        <ng-container *ngFor="let data of customerInterest">
                          <option [value]="data.id + ':' + data.interest"
                            [selected]="data.id + ':' + data.interest === originalLeadDetails.customerInterestId">
                            {{ data.interest }}
                          </option>
                        </ng-container>
                      </select>
                      <div *ngIf="submitted && f['customer_interest'].errors" class="invalid-feedback">
                        <div *ngIf="productForm.get('customer_interest')?.errors?.['required']" class="error-msg">
                          Please Select Buyer Type.
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <tr>
                  <td class="sub-head">call records</td>
                  <td style="padding:10px 8px 8px 10px">
                    <!-- <button title="Click to Open" class="btn btn-light-audio"
                      *ngIf="leadDetails.audio_path != null && leadDetails.call_status == 'ANSWER'"
                      (click)="openAudioDialog()">Open Audio Player</button> -->
                    <img src="/assets/images/play.png" alt="" style="cursor: pointer;" title="Open Audio"
                      *ngIf="leadDetails.audio_path != null && (leadDetails.call_status == 'Answered' || leadDetails.call_status == 'ANSWER')"

                      (click)="openAudioDialog()">
                    <span *ngIf="leadDetails.call_status != 'Answered' && leadDetails.call_status != 'ANSWER'"> -</span>
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">Finance Source </td>
                  <td *ngIf="!isEditMode">{{ leadDetails?.finance || '-' }}</td>
                  <td *ngIf="isEditMode">
                    <select style="font-size: 12px !important;" [(ngModel)]="originalLeadDetails.financeId"
                      class="form-select" (change)="onFieldEdit()">
                      <option disabled selected value="">Select Finance Source</option>
                      <ng-container *ngFor="let data of financeList">
                        <option [value]="data.id + ':' + data.finance"
                          [selected]="data.id + ':' + data.finance === originalLeadDetails.financeId">
                          {{ data.finance }}
                        </option>
                      </ng-container>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">Dealer</td>
                  <td>{{leadDetails?.outlet_details?.outlet || '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Parent Dealer</td>
                  <td>{{leadDetails?.outlet_details?.parent_dealer || '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Region</td>
                  <td>{{ leadDetails?.outlet_details?.region || '-' }}</td>

                </tr>
                <tr>
                  <td class="sub-head">Zone</td>
                  <td>{{leadDetails?.outlet_details?.zone || '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Message</td>
                  <td>{{leadDetails.message || '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Remarks</td>
                  <td>
                    <!-- {{leadDetails?.current_stage?.remarks ? leadDetails?.current_stage?.remarks: '-'}} -->
                    <div style="max-height:140px;overflow: auto;"
                      *ngIf="leadDetails?.current_stage?.remarks; else noRemarks">
                      <div *ngFor="let remark of leadDetails?.current_stage?.remarks | splitLines; let i =index;"
                        class="remark-item">
                        <span style="font-size: 13px;"> {{i+1}}. {{ remark }}</span>
                      </div>
                    </div>
                    <ng-template #noRemarks>
                      -
                    </ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- <div class="panel-footer mt-4" *ngIf="isEditMode">
              <button class="btn btn-blue mr-2" (click)="saveDetails()">Save</button>
              <button class="btn btn-light" (click)="cancelEdit()">Cancel</button>
            </div> -->
          </div>
        </div>
        <!-- <div class="icon-container">
          <img src="/assets/images/message.png" alt="SMS">
          <img src="/assets/images/whatsapp.png" alt="WhatsApp">
          <img src="/assets/images/email.png" alt="Email">
        </div> -->
      </div>
    </div>
  </div>
</div>

<div class="floating-icon" cdkDrag *ngIf="isVisible" [ngClass]="{'big-circle': isEditMode}">
  <mat-icon class="drag-icon" title="Drag" cdkDragHandle>drag_indicator</mat-icon>
  <mat-icon *ngIf="!isEditMode" class="edit-icon" (click)="editDetails()" title="Edit">edit</mat-icon>
  <div *ngIf="isEditMode" class="edit-actions">
    <mat-icon class="tick-icon mb-1" title="Save" *ngIf="isFieldEdited" (click)="saveDetails()">check</mat-icon>
    <mat-icon class="cross-icon" title="Cancel" (click)="cancelEdit()">close</mat-icon>
  </div>
</div>

<ng-template #audioDialog>
  <h2 mat-dialog-title class="ml-2">Audio Player</h2>
  <img class="close-audio-xbutton" mat-dialog-close src="/assets/images/close.png" alt="" (click)="closeAudio()">
  <mat-dialog-content>
    <div class="audio-player">
      <audio controls>
        <source [src]="'data:' + audioMimeType + ';base64,' + audioData">
        Your browser does not support the audio element.
      </audio>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions class="d-flex justify-content-end">
    <button mat-dialog-close class="btn white-btn mr-2" type="button" (click)="closeAudio()">Close</button>
  </div>
</ng-template>
